var _style, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.8 19.9",
    style: {
      enableBackground: "new 0 0 16.8 19.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 4.778,
    x2: 10.9212,
    y2: 4.778
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#22298F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07535076,
    style: {
      stopColor: "#2B42A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2047,
    style: {
      stopColor: "#3867B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3404,
    style: {
      stopColor: "#4286CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4818,
    style: {
      stopColor: "#4B9EDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6317,
    style: {
      stopColor: "#50AFE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7956,
    style: {
      stopColor: "#54B9ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#55BCEF"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "10.9,0 8.7,9.6 0,7.4 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.5462,
    y1: 2.9492,
    x2: 16.4573,
    y2: 14.2272
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001108285,
    style: {
      stopColor: "#55BCEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1858,
    style: {
      stopColor: "#4C9CDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4077,
    style: {
      stopColor: "#447CC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6224,
    style: {
      stopColor: "#3E65B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8241,
    style: {
      stopColor: "#3A57B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3952AE"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "10.9,0 16.8,13.1 8.7,9.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.4367,
    y1: 14.7436,
    x2: 16.8441,
    y2: 14.7436
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002198401,
    style: {
      stopColor: "#3952AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3952AE"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "8.7,9.6 16.8,13.1 4.4,19.9 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 13.6515,
    x2: 23.8714,
    y2: 13.6515
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001108285,
    style: {
      stopColor: "#3952AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1858,
    style: {
      stopColor: "#4272C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4077,
    style: {
      stopColor: "#4A92D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6224,
    style: {
      stopColor: "#50A9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8241,
    style: {
      stopColor: "#54B7EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#55BCEF"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "8.7,9.6 0,7.4 4.4,19.9 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCube);
export default __webpack_public_path__ + "static/media/blue-cube.380ffc2cd2d47bbce8c3d67b4c74ff6d.svg";
export { ForwardRef as ReactComponent };